/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_USERDATA,
 *     jwt: string
 * }
 */
export const SET_USERDATA = 'SET_USERDATA';
export const TOGGLE_OWN_AUDIO_INPUT = 'TOGGLE_OWN_AUDIO_INPUT';
export const SET_OTHERS_AUDIO_INPUT_ENABLED = 'SET_OTHERS_AUDIO_INPUT_ENABLED';
